import type { CmmdEnsuredProjectRepository } from "@cmmd-forge/contracts";

import { handleCmmdAuthExpired } from "./cmmdApi/cmmdAuthRedirect";
import { request } from "./cmmdApi/transport";
import { resolvePrimaryEnvironmentHttpUrl } from "./primary/target";

export interface EnsureProjectRepositoryParams {
  readonly projectId: number;
  readonly cmmdOrganizationId: number;
  readonly owner: string;
  readonly name: string;
  readonly visibility?: "private" | "public";
  readonly description?: string;
  readonly autoInit?: boolean;
}

export function ensureProjectRepository(
  params: EnsureProjectRepositoryParams,
): Promise<CmmdEnsuredProjectRepository> {
  return request<CmmdEnsuredProjectRepository>(
    {
      method: "POST",
      path: `/.well-known/forge/cmmd/projects/${params.projectId}/repository/ensure`,
      body: {
        cmmdOrganizationId: params.cmmdOrganizationId,
        owner: params.owner,
        name: params.name,
        ...(params.visibility ? { visibility: params.visibility } : {}),
        ...(params.description ? { description: params.description } : {}),
        ...(params.autoInit !== undefined ? { autoInit: params.autoInit } : {}),
      },
    },
    {
      resolveUrl: resolvePrimaryEnvironmentHttpUrl,
      onAuthExpired: handleCmmdAuthExpired,
    },
  );
}
